import React from 'react';
import { connect } from 'react-redux';
import noop from 'lodash/noop';
import { NotificationManager } from 'react-notifications';

import Button from 'ui/Button';

import useUpdateCoupon from '../state/useUpdateCoupon';
import useOffersData from 'features/SpilKlub/state/useOffersData';

import {
    combinationCount,
    combinationPrice,
    selections,
} from '../../../components/big9/selectors';

import t from '../texts';
import { selectionsChanged } from '../state/helpers';

const UpdateCouponButton = ({
    shown,
    originalCoupon,
    originalSelections,
    closeEditor,
    disabled,
    refetchPoolDetails,
    // store
    updatedSelections,
    updatedCombinationCount,
    updatedCombinationPrice,
}) => {
    const { extId } = useOffersData();

    const { updateCoupon } = useUpdateCoupon({
        poolId: originalCoupon.poolId,
        couponId: originalCoupon.couponId,
        extId,
        combinationCount: updatedCombinationCount,
        combinationPrice: updatedCombinationPrice,
        selections: updatedSelections,
        originalCoupon,
    });

    const combPriceChanged =
        updatedCombinationPrice !== originalCoupon.combinationPrice;

    const save = () =>
        updateCoupon()
            .then(refetchPoolDetails)
            .then(() => NotificationManager.success(t.coupon.couponUpdated))
            .catch(() => NotificationManager.error(t.coupon.couponUpdateFail))
            .finally(closeEditor);

    const showSaveButton =
        shown &&
        (selectionsChanged(originalSelections.outcomes, updatedSelections) ||
            combPriceChanged);

    return (
        showSaveButton && (
            <Button
                style={{
                    filter: disabled ? 'contrast(70%)' : 'contrast(100%)',
                }}
                onClick={disabled ? noop : save}
                green
                className="save-changes-btn fade-in"
            >
                Gem udkast
            </Button>
        )
    );
};

const stateToProps = (state) => ({
    updatedCombinationPrice: combinationPrice(state),
    updatedCombinationCount: combinationCount(state),
    updatedSelections: selections(state),
});

export const ConnectedUpdateCouponButton = connect(stateToProps)(
    UpdateCouponButton
);

export default UpdateCouponButton;
